var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"record_list"},_vm._l((_vm.recordList),function(item,index){return _c('li',{key:index,staticClass:"record_item"},[_c('span',[_vm._v(_vm._s(item.num))]),_c('span',[_vm._v(_vm._s(item.label))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }